export default __webpack_public_path__ + "static/media/puffin.7468aede.png";